export default __webpack_public_path__ + "static/media/arrowRight.cc70c95e.svg";